<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="board.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                @blur="$emit('on-name-change', board.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="buttonText">Button Text</label>
            <input
                id="buttonText"
                v-model="board.buttonText"
                class="form-control"
                :class="{
                    'is-invalid': hasError('buttonText')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('buttonText') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="description">Description</label>
            <textarea
                id="description"
                v-model="board.description"
                type="textarea"
                class="form-control rtl"
                :class="{
                    'is-invalid': hasError('description')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="isPublic">Is Public</label>
            <b-form-checkbox v-model="board.isPublic" switch />
            <div class="invalid-feedback">
                {{ getError('isPublic') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="isPublic">Is Blocked Add Posts By Users</label>
            <b-form-checkbox v-model="board.isBlockedAddPostsByUsers" switch />
            <div class="invalid-feedback">
                {{ getError('isBlockedAddPostsByUsers') }}
            </div>
        </div>
        <div class="form-group col-12">
            <h5>Apply Form</h5>
            <div>
                <button class="my-1 btn btn-primary" @click="addNewForm">
                    Add New
                </button>
            </div>
            Search form
            <div class="row align-items-end">
                <form-selector
                    v-model="board.formId"
                    :error="getError('formId')"
                    class="col-6"
                />

                <div v-if="board.formId">
                    <button class="btn btn-secondary" @click="editForm">
                        Edit
                    </button>
                </div>
            </div>
        </div>

        <post-labels v-model="board.labels" :server-errors="serverErrors" />

        <post-params
            v-if="board.id"
            v-model="board.questions"
            :validation="validation.board.postParams"
            :board-id="board.id"
        />
    </div>
</template>

<script>
import FormSelector from '@/components/forms/Selector';
import PostParams from '@/components/boards/PostParams';
import PostLabels from '@/components/boards/PostLabels';

export default {
    components: {
        FormSelector,
        PostParams,
        PostLabels
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            board: {
                labels: {}
            }
        };
    },

    watch: {
        board() {
            this.$emit('input', this.board);
        }
    },

    created() {
        this.board = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation?.board[key]?.$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.board,
                this.serverErrors,
                key
            );
        },

        addNewForm() {
            this.$router.push(`/forms/add`);
        },

        editForm() {
            this.$router.push(`/forms/${this.board.formId}/edit`);
        }
    }
};
</script>
